import * as THREE from 'three';

/**
 * Get the nearest point on a set of meshes to a target position.
 * @returns
 */
export const findNearestPoint = (
  mesh: THREE.Mesh,
  targetPosition: THREE.Vector3,
):
  | {
      success: true;
      point: THREE.Vector3;
      distance: number;
    }
  | {
      success: false;
      point: null;
      distance: null;
    } => {
  const positions = mesh.geometry.attributes.position.array;
  let minDistance = Infinity;
  let nearestPoint = new THREE.Vector3();

  for (let i = 0; i < positions.length; i += 3) {
    const vertex = new THREE.Vector3(positions[i], positions[i + 1], positions[i + 2]).applyMatrix4(
      mesh.matrixWorld,
    );

    const distance = vertex.distanceTo(targetPosition);

    if (distance < minDistance) {
      minDistance = distance;
      nearestPoint.copy(vertex);
    }
  }

  const success = minDistance < Infinity;

  if (!success) {
    return { success: false, point: null, distance: null };
  }

  return {
    success: true,
    point: nearestPoint,
    distance: minDistance,
  };
};
